import { useEffect, useRef } from 'react';
import Chart from 'chart.js';

const Verticalgraphcanvas = ({ data, label, index }) => {
  const chartRef = useRef(null);
  const chartContainerRef = useRef(null);

  useEffect(() => {
    if (data) {
      if (chartRef.current) {
        // Destroy the existing Chart instance
        chartRef.current.destroy();
      }
      fillUpVerticalGraphCard(data);
    }
  }, [data]);

  const secondsToHoursAndMinutes = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  };

  const fillUpVerticalGraphCard = (data) => {
    const labels = data?.map((course) => course.name);
    const dataValues = data?.map((course) => {
      if (course.time_spent !== undefined) {
        return course.time_spent;
      } else if (course.users !== undefined) {
        return course.users;
      } else {
        return course.user_count;
      }
    });

    const formattedDataValues = dataValues.map(secondsToHoursAndMinutes);

    const backgroundColors = [
      'rgba(81, 205, 186, 0.36)',
      'rgba(87, 205, 81, 0.36)',
      'rgba(200, 205, 81, 0.36)',
      'rgba(205, 106, 81, 0.36)',
      'rgba(81,122,205,0.36)',
    ];
    const borderColor = ['#51cdba', '#57cd51', '#c8cd51', '#cd6a51', '#517ACD'];

    const { max, stepSize } = findMaxAndStepSize(dataValues, dataValues.length);

    const ctx = document.getElementById(chartContainerRef.current.id);
    chartRef.current = new Chart(ctx, {
      type: 'horizontalBar',
      data: {
        labels: labels,
        datasets: [
          {
            label: label,
            data: dataValues,
            backgroundColor: backgroundColors,
            borderColor: borderColor,
            borderWidth: 2,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              if (label === 'Time Spent') {
                return ` Time Spent ${secondsToHoursAndMinutes(tooltipItem.xLabel)}`;
              }
              return ` ${label} ${tooltipItem.xLabel}`;
            },
          },
        },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: max,
                stepSize: stepSize,
                callback: function (value) {
                  if (label === 'Time Spent') {
                    return secondsToHoursAndMinutes(value);
                  }
                  return value;
                },
              },
            },
          ],
          yAxes: [
            {
              barPercentage: 0.4,
              borderWidth: 10,
              stacked: true,
            },
          ],
        },
      },
    });
  };

  const findMaxAndStepSize = (values, numberOfIntervals) => {
    const max = Math.max(...values);
    const min = Math.min(...values);
    const range = max - min;
    const stepSize = range / numberOfIntervals;

    return { max, stepSize };
  };

  return (
    <canvas
      ref={chartContainerRef}
      id={`MeSeStatusCanvasIBL-${index}`}
      style={{ width: '95%', height: 150 }}
    />
  );
};

export default Verticalgraphcanvas;
